import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";

import { NzSafeAny } from "ng-zorro-antd/core/types";
import { InputBoolean } from "ng-zorro-antd/core/util";
import { NzThSelectionComponent } from "ng-zorro-antd/table";

@Component({
  selector: "th[uiSelections],th[uiChecked],th[uiShowCheckbox],th[uiShowRowSelection]",
  preserveWhitespaces: false,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: "th-selection.component.html",
})
export class UiThSelectionComponent extends NzThSelectionComponent {
  @Input("uiSelections") public nzSelections: Array<{ text: string; onSelect(...args: NzSafeAny[]): NzSafeAny }> = [];
  @Input("uiChecked") public nzChecked = false;
  @Input("uiDisabled") public nzDisabled = false;
  @Input("uiIndeterminate") public nzIndeterminate = false;
  @Input("uiShowCheckbox") @InputBoolean() public nzShowCheckbox = false;
  @Input("uiShowRowSelection") @InputBoolean() public nzShowRowSelection = false;
  @Output("uiCheckedChange") public readonly nzCheckedChange = new EventEmitter<boolean>();
}
